import { tKey } from 'ember-intl';

export const BENI_SMART_COMPSET_BUILDER_MESSAGE_TYPES = {
  SUCCESS_UPDATE: 'successUpdate',
  FAIL_UPDATE: 'failUpdate',
} as const;

export type BeniSmartCompsetBuilderMessageType =
  (typeof BENI_SMART_COMPSET_BUILDER_MESSAGE_TYPES)[keyof typeof BENI_SMART_COMPSET_BUILDER_MESSAGE_TYPES];

export const BENI_SMART_COMPSET_BUILDER_MESSAGES: Record<
  BeniSmartCompsetBuilderMessageType,
  string
> = {
  [BENI_SMART_COMPSET_BUILDER_MESSAGE_TYPES.SUCCESS_UPDATE]: tKey(
    'benchmark_insight.smart-compset.builder.update.success',
  ),
  [BENI_SMART_COMPSET_BUILDER_MESSAGE_TYPES.FAIL_UPDATE]: tKey(
    'benchmark_insight.smart-compset.builder.update.fail',
  ),
} as const;

export const BENI_SMART_COMPSET_BUILDER_CHAIN_TRANSLATIONS: string[] = [
  tKey('benchmark-insight.smart-compset.smart-compset-builder.chain.accor'),
  tKey(
    'benchmark-insight.smart-compset.smart-compset-builder.chain.best-western',
  ),
  tKey('benchmark-insight.smart-compset.smart-compset-builder.chain.choice'),
  tKey('benchmark-insight.smart-compset.smart-compset-builder.chain.hilton'),
  tKey('benchmark-insight.smart-compset.smart-compset-builder.chain.hyatt'),
  tKey('benchmark-insight.smart-compset.smart-compset-builder.chain.ihg'),
  tKey('benchmark-insight.smart-compset.smart-compset-builder.chain.louvre'),
  tKey('benchmark-insight.smart-compset.smart-compset-builder.chain.marriott'),
  tKey('benchmark-insight.smart-compset.smart-compset-builder.chain.wyndham'),
  tKey(
    'benchmark-insight.smart-compset.smart-compset-builder.chain.independent',
  ),
];

export const BENI_SMART_COMPSET_BUILDER_TIMEOUT_CHAIN = 1000;
export const BENI_SMART_COMPSET_BUILDER_NUMBER_OF_DOTS = 3;
export const BENI_SMART_COMPSET_BUILDER_TIMEOUT_DOTS =
  BENI_SMART_COMPSET_BUILDER_TIMEOUT_CHAIN /
  BENI_SMART_COMPSET_BUILDER_NUMBER_OF_DOTS; // 3 dots, so 1/3 of the chain timeout

// Show the validation page for at least this amount of time, to make sure the user cycles through all of the chains.
export const BENI_SMART_COMPSET_BUILDER_VALIDATION_TIME =
  BENI_SMART_COMPSET_BUILDER_TIMEOUT_CHAIN *
  BENI_SMART_COMPSET_BUILDER_CHAIN_TRANSLATIONS.length;
